import { render, staticRenderFns } from "./resourceCommon.vue?vue&type=template&id=3a1e405d&scoped=true&"
import script from "./resourceCommon.vue?vue&type=script&lang=js&"
export * from "./resourceCommon.vue?vue&type=script&lang=js&"
import style0 from "./resourceCommon.vue?vue&type=style&index=0&id=3a1e405d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1e405d",
  null
  
)

export default component.exports